import theme from '@dbk/ui-theme';

export const SEPARATOR_STROKE = 'rgba(153,153,153,0.5)';

export const TYPOGRAPHY = {
  font: {
    family: {
      db: 'Univers Deutsche Bank',
    },
    size: {
      header1: 32,
      header2: 24,
      header3: 20,
      header4: 16,
      large: 16,
      normal: 14,
      small: 12,
      xsmall: 10,
      xxsmall: 8,
    },
    tabletSize: {
      header1: 35,
      header2: 27,
      header3: 25,
      header4: 19,
      large: 19,
      normal: 17,
      small: 15,
      xsmall: 13,
      xxsmall: 11,
    },
  },
};


export const INCOME_EXPENSE = {
  income: '#167F39',
  expense: '#A62103'
};

export const PALETTE = {
  primaryActive: theme.palettePrimaryActive,
  primaryText: '#edf2f1',
  primaryTextDisabled: '#999',
  primaryStrokeLine: SEPARATOR_STROKE,
  secondaryActive: '#ffffff',
  secondaryText: '#999',
  secondaryTextDisabled: '#333',
  secondaryDisabled: '#eceef0',
  secondaryBackground: '#333',
  lineChartColor: '#d4d73c',
  lineChartAxisColor: '#999',
  lineChartGridColor: '#999',
  bottomNavBackground: '#000',
  bottomNavSeparator: '#333',
  bottomNavItem: '#999',
  appBackground: '#000',
  errorColor: '#E3002D',
  successColor: '#7AB800',
  primaryInverseText: theme.palettePrimaryInverseDefaultText,
  // extras
  primaryNegative: '#fa3850',
  primaryPositive: '#7ab800',
  dbModalBackground: theme.paletteInverseSecondaryBorder,
  touchableOpacityEnable: '#00A3E0',
};

export const MARKER_COLOURS = {
  liquidity: {
    fill: '#E29317',
  },
  fixedincome: {
    fill: '#0098DB',
  },
  equity: {
    fill: '#7AB800',
  },
  alternatives: {
    fill: '#667A8F',
  },
  commodities: {
    fill: '#8996A0',
  },
  others: {
    fill: '#988F86',
  },
};

export const SIZES = {
  appHorizontalSpace: 10,
};

export const PAGE = {
  pageSize: 15,
};

export const ORIENTATIONS = {
  portrait: 'PORTRAIT',
  portraitUpsideDown: 'PORTRAITUPSIDEDOWN',
  landscape: 'LANDSCAPE',
  unknown: 'UNKNOWN',
};

export const CURRENCIESWITHOUTDECIMALS = [
  'JPY',
  'KRW',
  'ISK',
];

export const NUMBER_SCALE = [
  '',
  'app.constant.thousands',
  'app.constant.millions',
  'app.constant.billions',
  'app.constant.trillions',
  'app.constant.quadrillions',
  'app.constant.quintillions',
  'app.constant.sextillions',
  'app.constant.septillions',
  'app.constant.octillions',
  'app.constant.nonillions',
];

export const NO_DATA = '—';
export const NO_DATA_TEXT = 'app.portfolio.dashboard.noChartData';

export const APP_NAMESPACE = 'com.db.awm.uisdk.ebanking:';
export const MQ_TABLET = '@media (min-device-width: 700) and (max-device-width: 1224)';

export const SM_DEVICE = '@media (min-device-width: 0) and (max-device-width: 321)';
export const MD_DEVICE = '@media (min-device-width: 700) and (max-device-width: 1140)';

export const MOTION = {
  duration: 330,
  easing: {
    in: (k) => k * k * k * k * k,
    out: (k) => --k * k * k * k * k + 1, // eslint-disable-line no-param-reassign
  },
};

export const VASCO_MODAL_TYPES = {
  pin2fa: 'MODAL_PIN_2FA',
  notActivated: 'MODAL_VASCO_NOT_ACTIVATED',
  failUserLocked: 'MODAL_FAIL_USER_LOCKED',
  failExceededOtp: 'MODAL_FAIL_2FA_USER_LOCKED_EXCEEDED_OTP',
};

export const VASCO_FLOW = {
  noVasco: 'VASCO_DISABLED',
  notActivated: 'VASCO_NOT_ACTIVATED',
  browser: 'BROWSER',
};

export const DE = 'de';

export const ENTITLEMENT = {
  tradingModule: 'p4',
  YES: "Y",
  NO: "N"
};

export const ASSETS = {
  EQUITY: 'equity',
  BONDS: 'bonds',
  CASH: 'cash'
}

export const ALL_PORTFOLIO_ID = "00000000.00";

export const ALL_REPORT_PORTFOLIO = {
  "id": "00000000.00",
  "title": "All Portfolios",
  "referenceCurrency": "",
  "relId": null,
  "branchCode": 4,
  "isPaymentAvailable": true
};

export const EBANKINGWEBLUX = 'ebankingweblux';
export const RM_REGION = 'rmlux';

//  Added width and style as per VD 
export const ASSET_TAB_ICON_STYLE = {
 width: 50,
 height: 50
};
export const RIGHT_MENU_ICON_STYLE = {
  width: 24,
  height: 24,
}

export const REGION = {
  CH: 'CH',
  APAC: 'APAC'
}

export const PDF_NAME = {
  ONLINE_TERMS_ENGLISH: "DWO_UK_E-Banking_T&C_18012022.pdf.pdf",
  ONLINE_TERMS_GERMAN: "DWO_UK_E-Banking_T&C_18012022.pdf.pdf",
  NEW_EBANKING_ENGLISH : "new_e-banking_client_english.pdf",
  NEW_EBANKING_GERMAN : "new_e-banking_client_german.pdf",
  OLD_USER_ENGLISH :"DWO_UK_Migration_Guide_20221212.pdf",
  OLD_USER_GERMAN : "DWO_UK_Migration_Guide_20221212.pdf",
  TERMS_CONDITION_ENGLISH: "static/Online_Terms/UK/English/DWO_UK_E-Banking_T&C_18012022.pdf",
  TERMS_CONDITION_GERMAN: "static/Online_Terms/UK/English/DWO_UK_E-Banking_T&C_18012022.pdf.pdf",
}
export const LINKS_NAME = {
  FIRST_TIME_LOGIN: "first-time-login",
  REGISTER_NEW_DEVICE: "register-new-device",
  MOBILE_APP_GUIDE: "mobile-app-guide",
  FORGOT_PASSWORD: "forgot-password",
  USERNAME: "username"
}
export const KEY_CODE = {
  ENTER_KEY: 13,
  SPACE_KEY: 32
}